import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {AuthGuard} from "../guards/auth.guard";
import {PlanGuard} from "../guards/plan.guard";
import {AppService} from "../app.service";
import {VendorsComponent} from "./vendors.component";
import {VendorsImporterComponent} from "./vendors-importer/vendors-importer.component";

const routes: Routes = [
  {
    path: 'vendors',
    component: VendorsComponent,
    canActivate: [
      AuthGuard,
      PlanGuard
    ],
    data: { planFeature: AppService.FEATURES.ASSETS }
  },
  {
    path: 'vendors/importer',
    component: VendorsImporterComponent,
    canActivate: [
      AuthGuard,
      PlanGuard
    ],
    data: { planFeature: AppService.FEATURES.ASSETS }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class VendorsRoutingModule { }
